import { createRoute } from '@tanstack/react-router'

import { StaticRouteParameter } from 'config/routing'
import { Overview as InvitesOverview } from 'domains/MediaPlatforms/Settings/Permissions/Invites'
import { Overview as TeamsOverview } from 'domains/MediaPlatforms/Settings/Permissions/Teams'
import { Overview as UsersOverview } from 'domains/MediaPlatforms/Settings/Permissions/Users'
import { mediaPlatformSettingsLayoutRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Settings'

export const mediaPlatformSettingsPermissionsRoute = createRoute({
  getParentRoute: () => mediaPlatformSettingsLayoutRoute,
  path: StaticRouteParameter.PERMISSIONS,
  loader: () => null,
})

type MediaPlatformSettingsPermissionsUsersSearch = {
  query?: string
}

export const mediaPlatformSettingsPermissionsUsersOverviewRoute = createRoute({
  getParentRoute: () => mediaPlatformSettingsPermissionsRoute,
  path: '/',
  component: UsersOverview,
  validateSearch: (search: Record<string, unknown>): MediaPlatformSettingsPermissionsUsersSearch => ({
    ...(!!search.query && typeof search.query === 'string' && { query: search.query }),
  }),
})

type MediaPlatformSettingsPermissionsTeamsSearch = {
  query?: string
}

export const mediaPlatformSettingsPermissionsTeamsOverviewRoute = createRoute({
  getParentRoute: () => mediaPlatformSettingsPermissionsRoute,
  path: StaticRouteParameter.TEAMS,
  component: TeamsOverview,
  validateSearch: (search: Record<string, unknown>): MediaPlatformSettingsPermissionsTeamsSearch => ({
    ...(!!search.query && typeof search.query === 'string' && { query: search.query }),
  }),
})

type MediaPlatformSettingsPermissionsInvitesSearch = {
  query?: string
}

export const mediaPlatformSettingsPermissionsInvitesOverviewRoute = createRoute({
  getParentRoute: () => mediaPlatformSettingsPermissionsRoute,
  path: StaticRouteParameter.INVITATIONS,
  component: InvitesOverview,
  validateSearch: (search: Record<string, unknown>): MediaPlatformSettingsPermissionsInvitesSearch => ({
    ...(!!search.query && typeof search.query === 'string' && { query: search.query }),
  }),
})
